/* Brightholm - FAQ accordion.
   The cloned page ships .faq markup and the .faq.active CSS, but no script
   ever added the class, so every arrow was inert. */
(function () {
  'use strict';

  function init() {
    var headers = document.querySelectorAll('.faq .faq-header');
    if (!headers.length) return;

    Array.prototype.forEach.call(headers, function (header, i) {
      var faq = header.closest('.faq');
      var panel = faq && faq.querySelector('.faq-content-wrapper');
      if (!faq || !panel) return;

      if (!panel.id) panel.id = 'bh-faq-panel-' + i;
      header.setAttribute('role', 'button');
      header.setAttribute('tabindex', '0');
      header.setAttribute('aria-controls', panel.id);
      header.setAttribute('aria-expanded', faq.classList.contains('active') ? 'true' : 'false');

      function toggle(event) {
        event.preventDefault();
        var open = faq.classList.toggle('active');
        header.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      header.addEventListener('click', toggle);
      header.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
          toggle(event);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* A handful of blocks in the cloned page still render body copy at
     11-12.3px on a phone. The sizes are set by per-element <style> rules
     with generated class names, so raise them here rather than chase each
     selector. Scoped to the cloned sections - the theme footer is left
     alone. */
  function bumpSmallText() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    document.querySelectorAll('[class*="section_wrapper_"]').forEach(function (section) {
      section.querySelectorAll('p, span, li, div, a').forEach(function (el) {
        if (el.children.length) return;
        if ((el.textContent || '').trim().length < 4) return;
        var size = parseFloat(window.getComputedStyle(el).fontSize);
        if (size && size < 12.5) el.style.fontSize = '13px';
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bumpSmallText);
  } else {
    bumpSmallText();
  }

  /* The review videos are muted testimonials the visitor has to press play
     on. Letting them preload metadata still costs eight round trips on a
     phone connection. */
  window.addEventListener('load', function () {
    Array.prototype.forEach.call(document.querySelectorAll('video'), function (video) {
      if (!video.autoplay) video.preload = 'none';
    });
  });
})();

/* ------------------------------------------------------------------
   Le choix du format se fait sur /pages/commande. Tous les boutons
   d'achat de la page d'accueil y mènent, au lieu d'ajouter en dur le
   format 1 sachet au panier comme ils le faisaient.
   ------------------------------------------------------------------ */
(function () {
  var DEST = '/pages/commande';
  function rediriger() {
    Array.prototype.forEach.call(
      document.querySelectorAll('a[href*="/cart/"]'),
      function (a) {
        if (a.getAttribute('href') !== DEST) a.setAttribute('href', DEST);
      }
    );
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rediriger);
  } else {
    rediriger();
  }
  window.addEventListener('load', rediriger);
})();

/* Review video: the clone ships .revVideo, a .play_btn overlay and arrows but
   no slider JS, and the overlay swallowed every click. The video now loops
      muted on its own; one click anywhere on the slide turns the sound on. */
      (function () {
        function play(video) { var p = video.play(); if (p && p.catch) { p.catch(function () {}); } }
        function initReviewVideo() {
          Array.prototype.forEach.call(document.querySelectorAll('.revVideo'), function (video) {
            if (video.dataset.bhWired) { return; }
            video.dataset.bhWired = '1';
            var slide = video.closest('.revSlide') || video.parentElement;
            var badge = slide.querySelector('.play_btn');
            video.setAttribute('playsinline', ''); video.setAttribute('webkit-playsinline', '');
            video.loop = true; video.defaultMuted = true; video.muted = true; video.autoplay = true; video.preload = 'auto';
            slide.style.cursor = 'pointer'; slide.setAttribute('role', 'button'); slide.setAttribute('tabindex', '0');
            slide.setAttribute('aria-label', 'Temoignage cliente : activer le son');
            function paint() { if (badge) { badge.style.display = (video.muted || video.paused) ? '' : 'none'; } }
            function activate() {
              if (video.muted) { video.muted = false; video.volume = 1; video.currentTime = 0; slide.setAttribute('aria-label', 'Temoignage cliente'); play(video); paint(); return; }
              if (video.paused) { play(video); } else { video.pause(); }
              paint();
              }
              slide.addEventListener('click', activate);
              slide.addEventListener('keydown', function (event) { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); activate(); } });
              video.addEventListener('play', paint); video.addEventListener('pause', paint);
              play(video); paint();
              });
              }
              if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initReviewVideo); } else { initReviewVideo(); }
              window.addEventListener('load', initReviewVideo);
              })();